export default "__VITE_ASSET__ksqegK27__"